import { render, staticRenderFns } from "./ComponentPage.vue?vue&type=template&id=3d03ac79&"
import script from "./ComponentPage.vue?vue&type=script&lang=js&"
export * from "./ComponentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports